import { render } from "./TheMenuDialog.vue?vue&type=template&id=6bc82756&scoped=true"
import script from "./TheMenuDialog.vue?vue&type=script&lang=js"
export * from "./TheMenuDialog.vue?vue&type=script&lang=js"

import "./TheMenuDialog.vue?vue&type=style&index=0&id=6bc82756&lang=scss&scoped=true"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc82756"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QList,QItem,QItemSection,QSpace,QBtn,QAvatar});
